export default devTools => {
  return devTools && process.env.NODE_ENV === "development"
    ? devTools()
    : f => f;
};
